/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalUserMediaCenterFolderResponseV3CoverPictureFromJSON, InternalUserMediaCenterFolderResponseV3CoverPictureToJSON, } from './InternalUserMediaCenterFolderResponseV3CoverPicture';
/**
 * @export
 */
export const InternalUserMediaCenterFolderResponseV3TypeEnum = {
    MediaCenterFolder: 'media_center_folder'
};
/**
 * Check if a given object implements the InternalUserMediaCenterFolderResponseV3 interface.
 */
export function instanceOfInternalUserMediaCenterFolderResponseV3(value) {
    if (!('type' in value) || value['type'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
export function InternalUserMediaCenterFolderResponseV3FromJSON(json) {
    return InternalUserMediaCenterFolderResponseV3FromJSONTyped(json, false);
}
export function InternalUserMediaCenterFolderResponseV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'type': json['type'],
        'id': json['id'],
        'name': json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'coverPicture': json['cover_picture'] == null ? undefined : InternalUserMediaCenterFolderResponseV3CoverPictureFromJSON(json['cover_picture']),
    };
}
export function InternalUserMediaCenterFolderResponseV3ToJSON(json) {
    return InternalUserMediaCenterFolderResponseV3ToJSONTyped(json, false);
}
export function InternalUserMediaCenterFolderResponseV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'type': value['type'],
        'name': value['name'],
        'description': value['description'],
        'cover_picture': InternalUserMediaCenterFolderResponseV3CoverPictureToJSON(value['coverPicture']),
    };
}
